import clsx from 'clsx';
import classes from 'components/UI/V3/MetricBox/MetricBox.module.scss';
import React from 'react';

interface MetricBoxProps {
    title: string;
    value: string | number | React.ReactNode;
    isLoading?: boolean;
    className?: string;
}

const Skeleton: React.FC<{ className?: string }> = ({ className }) => {
    return (
        <div className={clsx(classes.root, classes.skeleton, className)}>
            <p className={classes.title}>&nbsp;</p>

            <p className={classes.value}>&nbsp;</p>
        </div>
    );
};

export const MetricBox: React.FC<MetricBoxProps> = ({ title, value, isLoading, className }) => {
    if (isLoading) {
        return <Skeleton className={className} />;
    }

    return (
        <div className={clsx(classes.root, className)}>
            <p className={classes.title}>{title}</p>

            <p className={classes.value}>{value}</p>
        </div>
    );
};
